module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("au6ub"))).then(() => parcelRequire('5erN3'));